// Audit event types the console can filter on, with the label shown for each. The Overview's
// recent-events card reuses the labels so both screens name an event the same way.
export const EVENT_OPTIONS = [
  { value: "", label: "All events" },
  { value: "auth.login", label: "Login" },
  { value: "auth.sso_login", label: "SSO login" },
  { value: "sso.config_created", label: "SSO connected" },
  { value: "sso.config_updated", label: "SSO settings changed" },
  { value: "sso.config_deleted", label: "SSO disconnected" },
  { value: "member.invited", label: "Member invited" },
  { value: "member.joined", label: "Member joined" },
  { value: "member.role_changed", label: "Role changed" },
  { value: "member.removed", label: "Member removed" },
  { value: "member.bulk_invited", label: "Bulk invite sent" },
  { value: "team.member_removed", label: "Team member removed" },
  { value: "team.member_role_changed", label: "Team role changed" },
  { value: "team.deleted", label: "Team deleted" },
  { value: "org.renamed", label: "Org renamed" },
  { value: "org.policy_updated", label: "Policy updated" },
  { value: "meeting.consent_acknowledged", label: "Meeting consent acknowledged" },
  { value: "meeting.recording_announced", label: "Meeting recording announced" },
  { value: "meeting.share_dispatched", label: "Meeting share dispatched" },
  { value: "meeting.share_emailed", label: "Meeting ready emailed" },
  { value: "meeting.share_slack", label: "Meeting ready posted to Slack" },
  { value: "meeting.share_skipped", label: "Meeting share skipped" },
  { value: "meeting.series_share_updated", label: "Meeting series share updated" },
  { value: "org.deletion_requested", label: "Org deletion requested" },
  { value: "org.deletion_canceled", label: "Org deletion canceled" },
  { value: "org.deleted", label: "Org deleted" },
  { value: "org.export_requested", label: "Data export requested" },
  { value: "domain.added", label: "Domain added" },
  { value: "domain.verified", label: "Domain verified" },
  { value: "join_link.created", label: "Join link created" },
  { value: "grackle.visibility_changed", label: "Visibility changed" },
  { value: "grackle.owner_reassigned", label: "Recording owner reassigned" },
  { value: "grackle.deleted", label: "Recording deleted" },
];

const LABELS = new Map(EVENT_OPTIONS.map((o) => [o.value, o.label]));

/** Human label for an audit event type; unknown types fall back to the raw dotted name. */
export function eventLabel(event: string): string {
  return LABELS.get(event) ?? event;
}
